import { handleActions } from "redux-actions";
import { CLEAR_NOTIFICATION, NOTIFICATION } from "./types";

const initState = {
  message: null,
  notification: null,
  error: false,
};

export default handleActions(
  {
    [NOTIFICATION]: (state, { payload }) => {
      return { ...state, ...payload };
    },
    [CLEAR_NOTIFICATION]: () => {
      return { message: null, notification: null, error: false };
    },
  },
  initState
);
